import React from 'react';
import type { Article } from '@/lib/mockArticles';

interface ArticleBodyProps {
  article: Article;
}

function renderContent(content: string) {
  const parts = content.split(/(<h2>.*?<\/h2>|<blockquote>.*?<\/blockquote>)/gs);
  return parts.map((part, i) => {
    if (part.startsWith('<h2>')) {
      const text = part.replace(/<\/?h2>/g, '');
      return (
        <h2 data-component-id="src/app/article-detail/components/ArticleBody.tsx:14:8" data-component-path="src/app/article-detail/components/ArticleBody.tsx" data-component-line="14" data-component-end-line="16" data-component-file="ArticleBody.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-serif-display%20text-2xl%20text-slate-900%20mt-10%20mb-4%22%7D" key={`body-h2-${i}`} className="font-serif-display text-2xl text-slate-900 mt-10 mb-4">
          {text}
        </h2>
      );
    }
    if (part.startsWith('<blockquote>')) {
      const text = part.replace(/<\/?blockquote>/g, '');
      return (
        <blockquote data-component-id="src/app/article-detail/components/ArticleBody.tsx:22:8" data-component-path="src/app/article-detail/components/ArticleBody.tsx" data-component-line="22" data-component-end-line="27" data-component-file="ArticleBody.tsx" data-component-name="blockquote" data-component-content="%7B%22elementName%22%3A%22blockquote%22%2C%22className%22%3A%22border-l-4%20border-primary-500%20pl-5%20pr-4%20py-3%20my-6%20bg-primary-50%2F60%20rounded-r-xl%20italic%20text-slate-700%20text-lg%20leading-relaxed%22%7D"
          key={`body-bq-${i}`}
          className="border-l-4 border-primary-500 pl-5 pr-4 py-3 my-6 bg-primary-50/60 rounded-r-xl italic text-slate-700 text-lg leading-relaxed"
        >
          {text}
        </blockquote>
      );
    }
    // Plain paragraphs
    const paragraphs = part.split('\n\n').filter(p => p.trim());
    return paragraphs.map((para, j) => (
      <p data-component-id="src/app/article-detail/components/ArticleBody.tsx:33:6" data-component-path="src/app/article-detail/components/ArticleBody.tsx" data-component-line="33" data-component-end-line="38" data-component-file="ArticleBody.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-article-body%20text-%5B17px%5D%20leading-%5B1.85%5D%20text-slate-700%20mb-6%22%7D"
        key={`body-p-${i}-${j}`}
        className="font-article-body text-[17px] leading-[1.85] text-slate-700 mb-6"
      >
        {para.trim()}
      </p>
    ));
  });
}

export default function ArticleBody({ article }: ArticleBodyProps) {
  return (
    <div data-component-id="src/app/article-detail/components/ArticleBody.tsx:45:4" data-component-path="src/app/article-detail/components/ArticleBody.tsx" data-component-line="45" data-component-end-line="55" data-component-file="ArticleBody.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-8%20max-w-3xl%22%7D" className="mt-8 max-w-3xl">
      {/* Lead paragraph */}
      <p data-component-id="src/app/article-detail/components/ArticleBody.tsx:47:6" data-component-path="src/app/article-detail/components/ArticleBody.tsx" data-component-line="47" data-component-end-line="49" data-component-file="ArticleBody.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-article-body%20text-lg%20leading-relaxed%20text-slate-800%20mb-6%20font-medium%20border-l-2%20border-primary-400%20pl-4%22%7D" className="font-article-body text-lg leading-relaxed text-slate-800 mb-6 font-medium border-l-2 border-primary-400 pl-4">
        {article.summary}
      </p>

      {/* Full content */}
      <div data-component-id="src/app/article-detail/components/ArticleBody.tsx:52:6" data-component-path="src/app/article-detail/components/ArticleBody.tsx" data-component-line="52" data-component-end-line="54" data-component-file="ArticleBody.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22article-body%22%7D" className="article-body">
        {renderContent(article.fullContent)}
      </div>
    </div>
  );
}